import React from "react";

interface Props extends React.HtmlHTMLAttributes<HTMLLabelElement> {
    label?: string;
    obrigatorio?: boolean;
    children?: React.ReactNode;
    htmlFor?: string;
}

export function Label(props: Props) {

    const { label, obrigatorio, style, children, ...labelProps } = props;

    return (
        <label
            style={
                style ? style : { fontWeight: "bold" }
            } 
            {...labelProps}
        >
            {children ? children : label}
            {obrigatorio ? <span style={{ color: "red" }}> *</span> : null}
        </label>
    )
}